// ISOFT Inventory Icon - Click to go to Inventory Management (Only for Stock Managers)
(function() {
    'use strict';
    
    function initInventoryIcon() {
        // Fetch settings to determine access dynamically
        frappe.call({
            method: 'isoft_invenza.isoft_invenza.utils.get_invenza_settings',
            callback: function(r){
                const s = r.message || {};
                if (!isUserAllowedForInvenza(s)) return; // do not render icon
    
    // Create the inventory icon with proper styling
    const inventoryIcon = `
        <li class='nav-item dropdown dropdown-notifications dropdown-mobile inventory-icon' title="Inventory Management" aria-label="Inventory Management">
            <a href="#" class="inventory-button" id="inventory-navbar">
                <i class="fa fa-cubes"></i>
            </a>
        </li>`;

    // Add the icon to the navbar
    if ($('header.navbar > .container > .navbar-collapse > ul').length) {
        $('header.navbar > .container > .navbar-collapse > ul').prepend(inventoryIcon);
    }

    // Add click handler to open inventory and redirect to home
    $(document).on('click', '#inventory-navbar', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Open inventory page in new tab/window
        window.open('/app/isoft-invenza', '_blank');
        
    });

    // Add CSS styles for the inventory icon
    const inventoryStyles = `
        <style>
            .inventory-icon {
                margin-right: 8px;
            }
            
            .inventory-button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 40px;
                background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
                color: white;
                text-decoration: none;
                border-radius: 50%;
                font-weight: 500;
                transition: all 0.3s ease;
                box-shadow: 0 2px 8px rgba(116, 185, 255, 0.4);
                position: relative;
                overflow: hidden;
                cursor: pointer;
            }
            
            .inventory-button:hover {
                background: linear-gradient(135deg, #5f9fd8 0%, #0770c4 100%);
                color: white;
                text-decoration: none;
                transform: translateY(-2px) scale(1.05);
                box-shadow: 0 4px 16px rgba(116, 185, 255, 0.5);
            }
            
            .inventory-button:active {
                transform: translateY(0) scale(0.98);
                box-shadow: 0 2px 8px rgba(116, 185, 255, 0.4);
            }
            
            .inventory-button i {
                color: #ffffff;
                font-size: 18px;
                text-shadow: 0 1px 2px rgba(0,0,0,0.2);
            }
            
            .inventory-button::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
                transition: left 0.5s;
            }
            
            .inventory-button:hover::before {
                left: 100%;
            }
            
            @media (max-width: 768px) {
                .inventory-button {
                    width: 36px;
                    height: 36px;
                }
                .inventory-button i {
                    font-size: 16px;
                }
            }
        </style>
    `;

    // Add styles to head
    $('head').append(inventoryStyles);
            }
        });
    }

    function isUserAllowedForInvenza(settings){
        try {
            const mode = (settings.access_mode || 'By Role').toLowerCase();
            const roles = (settings.allowed_roles || []);
            const users = (settings.allowed_users || []);
            const me = (frappe.session && frappe.session.user) || (frappe.user && frappe.user.name) || '';
            if (mode === 'by user') {
                return users.includes(me);
            }
            // by role
            const myRoles = (frappe.user_roles || []);
            return roles.length ? roles.some(r => myRoles.includes(r)) : frappe.user.has_role('Stock Manager');
        } catch(e){ return false; }
    }
    
    // Initialize when frappe is ready
    if (typeof frappe !== 'undefined' && frappe.user) {
        // If frappe is already loaded
        $(document).ready(initInventoryIcon);
    } else {
        // Wait for frappe to load
        $(document).on('frappe:ready', initInventoryIcon);
    }
})();
